<script>
  import Chart from "chart.js/auto";
  import { onMount } from "svelte";

  // Component chart Model => passage de parametres
  // <Chartparam
  //     chartType={"bar"}
  //     chartDatasets={dataset}
  //     chartDataLabels={axeHerm}
  //  />
  export let chartType = "line"; //str
  export let chartDataLabels = ""; //str
  export let chartDatasets; //Objet => avantage on peut passer les couleur ou plusieurs ligne

  let ctx;
  let chartCanvas;

  onMount(async () => {
    // console.log("MD label : " + chartDataLabels);

    ctx = chartCanvas.getContext("2d");
    var chart = new Chart(ctx, {
      type: chartType,
      data: {
        labels: chartDataLabels,
        datasets: chartDatasets,
      },
    });
  });
</script>

<canvas bind:this={chartCanvas} id="myChart" />
